export default __webpack_public_path__ + "static/media/coa.e2387bb9.svg";